module.exports = __webpack_public_path__ + "img/top_center.8429d9dc.svg";